import { useForm, router } from '@inertiajs/react'
import Layout from '../../../components/Layout'

interface Definition { id: number; name: string; field_type: string; options: string[] }

interface Props {
  definitions: Definition[]
  can_manage: boolean
}

export default function CustomFieldDefinitionsIndex({ definitions, can_manage }: Props) {
  const { data, setData, post, processing, reset } = useForm({
    custom_field_definition: { name: '', field_type: 'text', options: [] as string[] }
  })

  function create(e: React.FormEvent) {
    e.preventDefault()
    post('/settings/custom_field_definitions', { onSuccess: () => reset() })
  }

  return (
    <Layout>
      <h1 className="text-3xl font-semibold mb-6" style={{ color: '#1B1B1B' }}>Custom Fields</h1>
      {can_manage && (
        <form onSubmit={create} className="bg-white border rounded-lg p-4 mb-6 flex items-end gap-3">
          <div className="flex-1">
            <label className="block text-xs text-text-muted mb-1">Name</label>
            <input required value={data.custom_field_definition.name} onChange={(e) => setData('custom_field_definition', { ...data.custom_field_definition, name: e.target.value })} className="w-full border rounded px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-xs text-text-muted mb-1">Type</label>
            <select value={data.custom_field_definition.field_type} onChange={(e) => setData('custom_field_definition', { ...data.custom_field_definition, field_type: e.target.value })} className="border rounded px-3 py-2 text-sm">
              <option value="text">Text</option><option value="number">Number</option><option value="date">Date</option><option value="single_select">Single select</option><option value="multi_select">Multi select</option>
            </select>
          </div>
          <button disabled={processing} className="px-4 py-2 text-sm text-white rounded-lg" style={{ backgroundColor: '#ED1C24' }}>Add field</button>
        </form>
      )}
      <div className="bg-white border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-text-muted uppercase">
            <tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Type</th><th></th></tr>
          </thead>
          <tbody>
            {definitions.map((d) => (
              <tr key={d.id} className="border-t">
                <td className="px-4 py-3 text-text-primary">{d.name}</td>
                <td className="px-4 py-3 text-text-muted">{d.field_type}</td>
                <td className="px-4 py-3 text-right">
                  {can_manage && <button onClick={() => { if (confirm('Delete field?')) router.delete(`/settings/custom_field_definitions/${d.id}`) }} className="text-xs text-[#ED1C24]">Delete</button>}
                </td>
              </tr>
            ))}
            {definitions.length === 0 && <tr><td colSpan={3} className="px-4 py-6 text-center text-text-muted">No custom fields yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </Layout>
  )
}
